import React, { ReactNode, createContext, useContext, useEffect, useMemo } from "react";
import { SocketClient } from "./SocketClient";
import { useUser } from "./UserProvider";

const SocketClientContext = createContext<SocketClient | null>(null);

export default function SocketClientProvider({ children }: { children: ReactNode }) {
  const socketClient = useMemo(() => new SocketClient(), []);
  const { user } = useUser();

  useEffect(() => {
    if (user) {
      socketClient.connect();
    }
    return () => socketClient.disconnect();
  }, [user, socketClient]);

  return (
    <SocketClientContext.Provider value={socketClient}>
      {children}
    </SocketClientContext.Provider>
  );
}

export function useSocketClient() {
  return useContext(SocketClientContext) as SocketClient;
}

export { type TUpdateAttributePayload } from "./ReconnectingSocket";
